<template>
  <div class="Production-Plan-Item">
        <PageTitle
            imagem="pop2.png"
            main="Cadastro de Itens do Plano de Safra"
            sub=""
        />
       <ProductionPlanEditor />
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import ProductionPlanEditor from "./ProductionPlanEditor";

export default {
  name: "ProductionPlanItem",
  components: { PageTitle ,ProductionPlanEditor},
  beforeDestroy(){
    this.$store.commit("setMapList", null)
  }
};
</script>



<style>




</style>